// extracted by mini-css-extract-plugin
export default {"title":"D5-z","warning":"E5-z","sizeOptionsLegendText":"F5-z"};